import { defineStore } from 'pinia'

const useFormularioViewStore = defineStore('formulario-view', {
  state: () => ({
    isFormularioBot: false,
  }),

  actions: {
    setFormularioBot(v) {
      this.isFormularioBot = v
    },
  },
})

export default useFormularioViewStore
